<template>
  <div class="user-setting-phone">
    <van-form @submit="onSubmit" class="user-setting-phone-form">
      <van-field
        v-model="telphone"
        :rules="[
          {
            required: true,
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '请填写正确的手机号'
          }
        ]"
        type="number"
        placeholder="请输入手机号"
      />
      <van-field
        v-model="verifyCode"
        :rules="[{ required: true, message: '请填写图形验证码' }]"
        placeholder="请输入图形验证码"
      >
        <img
          slot="right-icon"
          :src="verifyCodeImage"
          @click="getVerifyCode"
          alt=""
        />
      </van-field>
      <van-field
        v-model="phoneCode"
        :rules="[{ required: true, message: '请填写短信验证码' }]"
        placeholder="短信验证码"
      >
        <span
          slot="right-icon"
          v-if="verifyCodeImage"
          :style="countDownTime ? 'color: gray;' : 'color: blue'"
          :disabled="countDownTime > 0"
          @click="sendCode"
          class="user-setting-phone-send-verifycode"
        >
          {{ countDownTime ? `${countDownTime}s后重新发送` : "发送验证码" }}
        </span>
      </van-field>
      <ph-button
        class="user-setting-phone-commit-button"
        title="确认绑定"
        native-type="submit"
      />
    </van-form>
    <div class="user-setting-phone-tips">
      注意：绑定手机时请您认真阅读以下注意事项
      <div>
        1、一个微信号只允许绑定一个手机号，请结合验证码进行认证绑定，如需修改可进入"我的"点击"修改手机"进行修改
      </div>
      <div>
        2、如您之前在龙岩人民医院公众号注册过，请您务必绑定之前注册的手机号，以免之前的卡包数据无法关联，影响您的使用
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      telphone: "",
      verifyCode: "",
      phoneCode: "",
      verifyCodeId: "",
      verifyCodeImage: "",
      countDownTime: 0,
      timer: null
    };
  },
  created() {
    if (!localStorage.getItem("init")) {
      alert("请认真阅读注意事项");
      localStorage.setItem("init", true);
    }
    this.getVerifyCode();
  },
  methods: {
    bind() {},
    getVerifyCode() {
      this.$http.post(this.$api.USER_VERIFY_CODE, {}).then(res => {
        this.verifyCodeId = res.picId;
        this.verifyCodeImage = res.url;
      });
    },
    sendCode() {
      if (!this.telphone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.verifyCode) {
        this.$toast("请输入图形验证码");
        return;
      }
      this.$http
        .post(this.$api.USER_SEND_VERIFY_CODE, {
          picId: this.verifyCodeId,
          picCode: this.verifyCode,
          telmobile: this.telphone
        })
        .then(() => {
          this.startCountDown();
        });
    },
    onSubmit() {
      this.$http
        .post(this.$api.USER_BIND_PHONE, {
          phone: this.telphone,
          smsCode: this.phoneCode
        })
        .then(() => {
          this.$toast("绑定成功");
          this.$router.go(-1);
        });
    },
    startCountDown() {
      clearInterval(this.timer);
      this.timer = null;
      this.countDownTime = 60;
      this.timer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="less">
.user-setting-phone {
  background: @primary-gray;

  &-form {
    padding: 0.8rem;
    background: white;

    .van-cell {
      padding: 0.6rem 0;
      border-bottom: 1px solid @primary-gray;
      input::-webkit-input-placeholder {
        color: gray;
      }
    }

    .van-cell::after {
      position: relative;
    }

    .van-field__body {
      font-size: 0.94rem;
    }
  }

  &-send-verifycode {
    font-size: 0.8rem;
    line-height: 1.5rem;
  }

  &-commit-button {
    width: 100%;
    margin: 1rem 0 0 0;
    line-height: 2.5rem;
  }

  &-tips {
    margin: 1rem 0.4rem;
    color: red;
    font-size: 0.8rem;
    div {
      color: gray;
    }
  }
}
</style>
